module.exports = __webpack_public_path__ + "img/mail.bcb191d1.svg";